module.exports = __webpack_public_path__ + "static/media/idun18.ca659454.JPG";